import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import { IState, ContentSelectors } from '../../../redux/selectors';

const workoutCategories = (state: IState) => state.workoutCategories;

const workoutCategoriesContent = createSelector(
  workoutCategories,
  (workoutCategories: any) => {
    return workoutCategories.workoutCategoriesContent;
  },
);

const workoutCategoriesResolve = createSelector(
  workoutCategoriesContent,
  ContentSelectors.workoutCategory.indexedBy.id,
  (workoutCategoriesList, workoutCategoriesIndex) => {
    let defaultCategoriesResolved = [];
    let targetedCategoriesResolved = [];
    if (!isEmpty(workoutCategoriesList)) {
      const { defaultCategories, targetedCategories } = workoutCategoriesList;
      if (!isEmpty(defaultCategories)) {
        defaultCategories.forEach((item: any) => {
          const workoutCategoryInfo = workoutCategoriesIndex[item.id]?.fields;
          if (workoutCategoryInfo) {
            const data = {
              node: {
                name: workoutCategoryInfo.name,
                slug: workoutCategoryInfo.slug,
                color: workoutCategoryInfo.color,
                fontColor: workoutCategoryInfo.fontColor,
                tileTextColor: workoutCategoryInfo.tileTextColor,
                tileTextBgColor: workoutCategoryInfo.tileTextBgColor,
              },
            };
            defaultCategoriesResolved.push(data);
          }
        });
      }
      if (!isEmpty(targetedCategories)) {
        targetedCategories.forEach((item: any) => {
          const workoutCategoryInfo = workoutCategoriesIndex[item.id]?.fields;
          if (workoutCategoryInfo) {
            const data = {
              node: {
                name: workoutCategoryInfo.name,
                slug: workoutCategoryInfo.slug,
                color: workoutCategoryInfo.color,
                fontColor: workoutCategoryInfo.fontColor,
                tileTextColor: workoutCategoryInfo.tileTextColor,
                tileTextBgColor: workoutCategoryInfo.tileTextBgColor,
              },
            };
            targetedCategoriesResolved.push(data);
          }
        });
      }
    }
    const workoutCategoriesResolved = {
      defaultCategories: [...defaultCategoriesResolved],
      targetedCategories: [...targetedCategoriesResolved],
    };
    return workoutCategoriesResolved;
  },
);

export default {
  workoutCategoriesContent,
  workoutCategoriesResolve,
};
